/**
 * MODULE: _shared/frontend-shell/src/design-system/CommandPalette/paletteProviders.ts
 * PURPOSE: Ordered palette provider registry (extend here for CRM, files, etc.)
 */

import type { NavigateFunction } from 'react-router-dom';
import type { PaletteProvider } from './types';
import { createContentPaletteProvider } from './providers/contentProvider';

/** Debounce for network-backed providers is applied in GlobalSearch (200ms). */
export function createCommandPaletteProviders(navigate: NavigateFunction): PaletteProvider[] {
  return [createContentPaletteProvider(navigate)];
}
